import { onReady } from './util/onReady';
import { initDropdown } from '@bi-digital/react/vanilla';

onReady(() => {
    initDropdown({ id: 'language-switch-dropdown', placement: 'bottom-end' });
    initDropdown({ id: 'user-menu-dropdown', placement: 'bottom-end' });
});
